import React from 'react';
// import { RiStarFill } from 'react-icons/ri';
import Title from '../layouts/Title';
import { meabout } from '../../assets';

const About = () => {
  return (
    <section id="about" className="w-full py-20 border-b-[1px] border-b-black">
      <div className="flex justify-center items-center text-center">
        <Title title="Who Am I" des="About Us" />
      </div>
      <div className="max-w-6xl mx-auto">
        <div className="w-full">
            <div className="w-full h-auto flex flex-col lgl:flex-row justify-between">
                <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#053F5E] to-[#115173] p-8 rounded-lg shadow-shadowOne flex flex-col md:flex-row lgl:flex-col gap-8 justify-center md:justify-start lgl:justify-center">
                    <img className="h-72 md:h-32 lgl:h-72 rounded-lg object-cover" src={meabout} alt="meabout" />
                <div className="w-full flex flex-col justify-end">
                    <h3 className="text-2xl font-bold  text-designColor">Farah Aryaresta</h3>
                    <p className="text-base tracking-wide text-gray-300">UIUX Designer | FrontEnd Web Developer</p>
                </div>
                </div>
                <div className="w-full lgl:w-[60%] h-full flex flex-col justify-between">
                    <div className="w-full h-[70%] py-10 bg-gradient-to-r from-[#053F5E] to-[#115173] rounded-lg shadow-shadowOne p-4 lgl:p-8 flex flex-col justify-center gap-4 lgl:gap-8">
                        <div className="flex flex-col justify-between lgl:items-center  border-b-2 border-b-gray-900">
                            <div>
                                <h3 className="text-xl lgl:text-2xl font-medium tracking-wide py-2">Hai, i'm Farah Aryaresta</h3>
                            </div>
                            {/* <div className="text-yellow-500 flex gap-1">
                                <RiStarFill />
                            </div> */}
                        </div>
                        <p className="text-base font-titleFont text-justify text-gray-300 font-medium tracking-wide leading-6">
                        Saya adalah lulusan dari Program Studi Teknik Informatika di Universitas Dian Nuswantoro Semarang. Selama studi, saya memperoleh pengetahuan mendalam mengenai teknologi informasi dan fokus meraih nilai yang baik dengan
                        aktif bergabung dalam berbagai organisasi, magang, dan pelatihan. Melalui berbagai kegiatan tersebut, saya mendapatkan pengalaman dalam analisis data dan manajemen, serta keahlian dalam pengelolaan tim, perencanaan
                        strategis, dan penyelesaian masalah. Saya memiliki minat di dunia IT dengan spesialisasi dalam bidang Desain UI/UX dan Pengembangan Front-End Aplikasi Website. Saya antusias untuk terus belajar, mengembangkan diri, dan
                        siap menerima rekomendasi untuk meningkatkan keterampilan dan pola pikir saya.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div className="w-full lgl:w-[60%] h-full flex flex-col justify-between pt-10">
            <div className="w-full h-[70%] py-10 bg-gradient-to-r from-[#053F5E] to-[#115173] rounded-lg shadow-shadowOne p-4 lgl:p-8 flex flex-col gap-4 lgl:gap-8">
                <div className="flex flex-col lgl:flex-row gap-4 lgl:gap-8">
                {/* Column 1 */}
                <div className="flex-1">
                    <div className="flex flex-col gap-2">
                    <div className="flex items-center">
                        <span className="w-24 font-medium text-gray-300">Name</span>
                        <span className="text-gray-300"> : Farah Aryaresta, S.Kom</span>
                    </div>
                    <div className="flex items-center">
                        <span className="w-24 font-medium text-gray-300">Age</span>
                        <span className="text-gray-300"> : 22 years</span>
                    </div>
                    <div className="flex items-center">
                        <span className="w-24 font-medium text-gray-300">Phone</span>
                        <span className="text-gray-300"> : +62895363416758</span>
                    </div>
                    <div className="flex items-center">
                        <span className="w-24 font-medium text-gray-300">Email</span>
                        <span className="text-gray-300"> : faraaryaresta@gmail.com</span>
                    </div>
                    </div>
                </div>
                {/* Column 2 */}
                <div className="flex-1">
                    <div className="flex flex-col gap-2">
                    <div className="flex items-center">
                        <span className="w-24 font-medium text-gray-300">Address</span>
                        <span className="text-gray-300"> : Wonogiri, Jawa Tengah</span>
                    </div>
                    <div className="flex items-center">
                        <span className="w-24 font-medium text-gray-300">Availability</span>
                        <span className="text-gray-300"> : Fulltime, Freelance</span>
                    </div>
                    <div className="flex items-center">
                        <span className="w-24 font-medium text-gray-300">Experiences</span>
                        <span className="text-gray-300"> : 2 years</span>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </section>
  );
};

export default About;
